import { useContext, useEffect } from 'react';
import { SnackbarProvider, useSnackbar } from 'notistack';
import { AuthContext } from 'features/auth/store/auth.provider';
import { useWindowSize } from 'hooks/useWindowSize';
import { useLocalStorage } from 'react-haiku';
import { setApiEnqueueSnackbar } from 'controllers/Api.controller';

import Navbar from '../Navbar';
import NavbarMobile from '../NavbarMobile';
import UserBar from '../UserBar';

import './style.css';

const ApiSnackbarBridge = () => {
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    setApiEnqueueSnackbar(enqueueSnackbar);
    return () => setApiEnqueueSnackbar(null);
  }, [enqueueSnackbar]);

  return null;
}

const Layout = ({ children }) => {
  const auth = useContext<any>(AuthContext);
  const [open, setOpen] = useLocalStorage("openNavbar", true);
  const { width, height } = useWindowSize();
  const navbar_name = open ? 'navbar-container' : 'navbar-container-closed';
  const navbar_little_nav : {} = width < 1250 ?  {
    minHeight : height-60+"px",
    height : height-60+"px",
    position : "fixed",
    zIndex : 10,
  } : {
    minHeight : height-60+"px",
    height : height-60+"px",
  }

  const bodyContainer_little_nav : {} = width < 1250 && width > 1200 ? {
    flex : 2,
    backgroundColor : "#22252D",
    marginLeft : 50+"px"
  } : {
    flex : 2,
    backgroundColor : "#22252D"
  }
  if(auth.isLoading) return <div>Loading...</div>
  if(auth.user?._id){
    return (
      <SnackbarProvider maxSnack={3} anchorOrigin={{ vertical: 'top', horizontal: 'right', }}>
        <ApiSnackbarBridge />
        <div className="global-container" style={{ maxWidth : width+"px", maxHeight : height+"px" }}>
          <UserBar user={auth.user} />
          <div className='main-container' style={{ maxWidth : width+"px", maxHeight : height-60+"px" }}>
            {
              width > 1200 ?
                <div className={navbar_name} style={navbar_little_nav}>
                  <Navbar open={open} setOpen={setOpen} />
                </div>
              : 
                <NavbarMobile />
            }
            <div style={bodyContainer_little_nav}>
              <div className='global-view-container' style={{ minHeight : height-60+"px", height : height-60+"px" }}>
                { children }
              </div>  
            </div>
          </div>
        </div>
      </SnackbarProvider>
    )
  } else {
    return (
      <>
        { children }
      </>
    )
  }
}

export default Layout;
